import { useState } from 'react'
import webicon from '../../../../assets/webicon.png'
import magentoicon from '../../../../assets/magento.png'
import {
  DatasetSync,
  postDataToStore,
  updateStore,
  Validatescript,
  ValidatewebsiteUrl
} from '../../../../services/data'
import CreateStore from '../../../../util/createstore'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import { deleteStorebyID } from '../../../../services/data'
import TooltipWalkthrough from '../../../../util/walkthrough'
import { useSubscription } from '../../../../context/subscriptionprovider'
import { validate } from 'uuid'
import validateJSON from '../../../../util/jsonvalidation'
import VerifyDomainPopup from '../../../BotCustom/component/owner_verify_popup'
import Cookies from 'js-cookie'
import { useAuth } from '../../../../context/logincontext'

const GetMagentoStore = ({ handleback }) => {
  const [siteUrl, setSiteUrl] = useState('')
  const [accessToken, setAccessToken] = useState('')
  const navigate = useNavigate()
  const [storeID, SetstoreID] = useState('')

  const { isRestricted, activePlan, limitedPermission } = useSubscription()
  const [showVerifyPopup, setShowVerifyPopup] = useState(false)
  const [createdStoreId, setCreatedStoreId] = useState(null)
  const { userdata } = useAuth()
  const isAccessRestricted =
    isRestricted ||
    !limitedPermission ||
    limitedPermission.custom_dataset_training === false

  const handleBackClick = () => {
    handleback()
  }

  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const store_id = getStoreIdFromUrl()

  const cleanSiteUrl = url => {
    try {
      return new URL(url).hostname // Extracts domain only
    } catch (error) {
      return url.replace(/(^\w+:|^)\/\//, '') // Fallback method
    }
  }

  const handleInstallMagento = async () => {
    // let userId = userdata
    let userId = userdata ? validateJSON(userdata).id : null

    // let userId = Cookies.get('user')
    //   ? validateJSON(Cookies.get('user')).id
    //   : null

    if (!siteUrl || !accessToken) {
      toast.error('Please enter Site URL and Access Token', {
        position: 'bottom-center'
      })
      return
    }

    const urldata = {
      url: siteUrl
    }
    const res = await ValidatewebsiteUrl(urldata)

    if (res.success) {
      toast.success(res.message, {
        position: 'bottom-center'
      })
      const storeData = {
        name: cleanSiteUrl(siteUrl),
        type: 'magento',
        user_id: userId,
        status: 'unverified',
        meta: { token: accessToken }
      }
      var storeId = null
      try {
        // console.log('Creating store with data:', storeData)
        // toast.info('Onboarding is in progress. Please wait...', {
        //   position: 'bottom-center'
        // })
        const store = await CreateStore(storeData)

        if (store.success) {
          storeId = store.data.store_id
          // localStorage.setItem('store_id', storeId)
          SetstoreID(storeId)
          localStorage.setItem('storedata', JSON.stringify(store.data))
          if (store.data.status === 'unverified') {
            setShowVerifyPopup(true)
            return
          }

          // toast.warn('Redirecting to subscription page...', {
          //   position: 'bottom-center',
          //   autoClose: 4000
          // })

          // setTimeout(() => {
          //   localStorage.removeItem('onboarding')
          //   navigate('/subscription')
          // }, 4000)
        } else {
          toast.error(store.message, {
            position: 'bottom-center'
          })
        }
      } catch (error) {
        console.error('Error during store creation:', error)
        console.warn('DatasetSync failed, deleting store:', storeId)
        toast.error(error.message, {
          position: 'bottom-center'
        })
        const del = await deleteStorebyID(storeId)
        if (del.success) {
          localStorage.removeItem('store_id')
          localStorage.removeItem('storedata')
        }
      }
    }
  }

  const publishScript = `
  <script  
    src="${process.env.REACT_APP_API_URL}/js/loader.bundle.js" 
    async 
    data-store-id="${storeID}" 
    id="chatbot-script-loader" 
    defer
  ></script>`

  const DeletestoreOnCancel = async () => {
    const deleteresponse = await deleteStorebyID(store_id)
    if (deleteresponse.success) {
      localStorage.removeItem('store_id')
      localStorage.removeItem('storedata')
      setShowVerifyPopup(false)
    }
  }

  const ValidateScript = async () => {
    let res
    const data = {
      url: siteUrl,
      // storeId: '024b7238ba1350cf5a9d7b8460189078',
      storeId: store_id
    }
    const queryParams = new URLSearchParams(window.location.search)

    const skip_param = queryParams.get('skip_store_validation')
    // console.log(skip_param)
    if (skip_param === 'true') {
      res = {
        success: true
      }
    } else {
      res = await Validatescript(data)
    }

    if (res.success) {
      toast.success('Domain Verified Successfully', {
        position: 'bottom-center'
      })

      const updatedata = {
        status: 'active'
      }
      const updateres = await updateStore(store_id, updatedata)
      if (updateres.success) {
        toast.warn('Redirecting to subscription page...', {
          position: 'bottom-center',
          autoClose: 3000
        })
        setTimeout(() => {
          localStorage.removeItem('onboarding')
          navigate(`/store/${storeID}/subscription`)
          window.dispatchEvent(
            new CustomEvent('storeSwitchedtrigger', { detail: true })
          )
          window.dispatchEvent(
            new CustomEvent('storeChanger', { detail: true })
          )
        }, 4000)
      }
    } else {
      // toast.error(
      //   'Verification Failed – Script Not Found or Invalid Store URL',
      //   {
      //     position: 'bottom-center'
      //   }
      // )
    }
  }

  return (
    <>
      <div className='flex items-start w-full justify-between'>
        <div className='block'>
          <div className='flex items-start mb-1 justify-start'>
            <img src={magentoicon} alt='' />
            <h1 className='text-[#252530] ml-3 font-extrabold text-[23px] leading-[31px]'>
              Magento Store
            </h1>
          </div>
          <p className='text-[12px] ml-1'>
            Install a Magento Chatbot to Enhance Customer Interactions on Your
            Store.
          </p>
        </div>
        <button
          className='border border-[#7C50DD] rounded-[39px] flex items-center justify-start text-[14px] font-normal p-[10px] h-[44px] bg-white w-[103px]'
          aria-label='Go back'
          onClick={handleBackClick}
        >
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M16.1705 4.4545C16.6098 4.89384 16.6098 5.60616 16.1705 6.0455L10.216 12L16.1705 17.9545C16.6098 18.3938 16.6098 19.1062 16.1705 19.5455C15.7312 19.9848 15.0188 19.9848 14.5795 19.5455L7.8295 12.7955C7.39017 12.3562 7.39017 11.6438 7.8295 11.2045L14.5795 4.4545C15.0188 4.01517 15.7312 4.01517 16.1705 4.4545Z'
              fill='#7C50DD'
            />
          </svg>
          <span className='ml-2'>Back</span>
        </button>
      </div>

      <div className='mt-2 relative flex w-full'>
        <form className='w-full flex flex-col gap-5 relative'>
          <div className='flex flex-col gap-3'>
            <label className='text-base'>Magento Site URL</label>
            <input
              type='text'
              className='focus:outline-none magento-site-url-input w-full h-[56px] rounded-[39px] pl-[40px] sm:pr-[100px] pr-[70px] pt-[10px] pb-[10px] placeholder:text-[15px] placeholder:text-[#252530] font-normal'
              placeholder='Enter Magento store URL'
              value={siteUrl}
              onChange={e => setSiteUrl(e.target.value)}
            />
          </div>

          <div className='flex flex-col gap-3'>
            <label className='text-base'>Access Token</label>
            <input
              type='text'
              className='focus:outline-none w-full access-token-input h-[56px] rounded-[39px] pl-[40px] sm:pr-[100px] pr-[70px] pt-[10px] pb-[10px] placeholder:text-[15px] placeholder:text-[#252530] font-normal'
              placeholder='Enter Access Token'
              value={accessToken}
              onChange={e => setAccessToken(e.target.value)}
            />
            <span className='text-sm text-gray-500 ml-2'>
              How to generate Access Token?{' '}
              <a
                href='https://meetanshi.com/blog/magento-2-api-key'
                target='_blank'
                rel='noopener noreferrer'
                className='text-[#7C50DD]'
              >
                Step-by-Step Guide
              </a>
            </span>
          </div>
        </form>
      </div>

      <button
        onClick={handleInstallMagento}
        type='button'
        className='mt-3 bg-[#7C50DD] install-magbot-button cursor-pointer sm:mt-3 sm:relative flex items-center text-[12px] h-[36px] border-[1px] p-[20px] 
          text-white w-full sm:w-auto justify-center font-medium rounded-[20px]'
      >
        Install MagBot App
      </button>
      <ToastContainer />
      <TooltipWalkthrough pageKey={'/addchatbot'} />
      {showVerifyPopup && (
        <VerifyDomainPopup
          publishScript={publishScript}
          onClose={() => {
            setShowVerifyPopup(false)
            // DeletestoreOnCancel()
          }}
          onVerify={() => {
            // toast.info('Validating ownership using store_id...', {
            //   position: 'bottom-center'
            // })
            ValidateScript()
          }}
          siteurl={siteUrl}
        />
      )}
    </>
  )
}

export default GetMagentoStore
